import type { GameDefinition } from "../game";
import { PgxGo } from "./environment";
import { GoRenderer } from "./renderer";
import type { GoState } from "./types";

function createGoDefinition(
  size: number,
  variantId: string,
  modelId: string,
): GameDefinition<GoState> {
  const environment = new PgxGo(size);
  return {
    gameId: "go",
    gameName: "Go",
    variantId,
    variantName: `${size}×${size} · komi ${environment.komi}`,
    board: { width: size, height: size },
    observationShape: [size, size, 17],
    actionCount: size * size + 1,
    defaultSimulations: 32,
    defaultHumanPlayer: 1,
    modelIds: [modelId],
    playerNames: ["Black", "White"],
    controls: { pass: true },
    createEnvironment: () => environment,
    createRenderer: () => new GoRenderer(),
    createInferenceInput: (state) => ({
      observation: environment.observe(state),
      legalActionMask: environment.legalActionMask(state),
    }),
    statusText: (state) => state.terminated
      ? `${state.winner === 0 ? "Black" : "White"} wins · ${state.scores[0]}–${state.scores[1]}`
      : `${state.currentPlayer === 0 ? "Black" : "White"} to move · captures ${state.captures[0]}–${state.captures[1]}`,
    moveHistory: (state) => state.moves.map((move) => move.label),
  };
}

export const go3Definition = createGoDefinition(
  3,
  "go_3x3",
  "dainty-wind-11-v3",
);
export const go4Definition = createGoDefinition(
  4,
  "go_4x4",
  "zany-butterfly-8-v3",
);
export const go5Definition = createGoDefinition(
  5,
  "go_5x5",
  "brisk-violet-5-v4",
);
export { PgxGo } from "./environment";
export { GoRenderer } from "./renderer";
export type { GoMove, GoState } from "./types";
